import useTranslation from 'next-translate/useTranslation';
import React, { FunctionComponent, useState } from 'react';
import { UseFormRegister } from 'react-hook-form';

import Button from '../../ui/button';
import { Text } from '../../ui/inputs/generic-input';

const SignUpFormContent: FunctionComponent<{
  register: UseFormRegister<Record<string, any>>;
  errors: Record<string, any>;
  disabled: boolean;
  isValid: boolean;
}> = ({ register, errors, disabled, isValid }) => {
  const { t } = useTranslation();
  return <>
    <Text
      {...register('username', {
        required: t('forms:errors.required'),
        maxLength: {
          value: 150,
          message: t('forms:errors.maxLenght', { value: 150 }),
        },
        pattern: {
          value: /^\S+@\S+$/i,
          message: t('forms:errors.invalidEmail'),
        },
      })}
      label={t('forms:user.email.label')}
      type="email"
      id={`email`}
      placeholder={t('forms:user.email.placeholder')}
      disabled={disabled}
      error={errors?.username?.message}
    />

    <div className="flex w-full">
      <Button
        role="button"
        variant="CTA"
        data-action="submit"
        disabled={!isValid}
      >
        {t('password-reset:continue-btn')}
      </Button>
    </div>
  </>;
};
export default SignUpFormContent;
